import LocalizedStrings from "react-localization";
import UserSession from "../session/UserSession";

class LocalizationUtil {
  static possibleLanguages = ["hr", "en"];

  static getLocalizedText(text) {
    const localizedText = this.localize(text);
    return localizedText.text;
  }

  static localize(localizable) {
    const localized = new LocalizedStrings(localizable);

    const user = UserSession.getUser();
    const language =
      user && user.party && user.party.isoLanguage
        ? user.party.isoLanguage.isoCode
        : undefined;
    //if undefined, language will be browser's default
    if (language) {
      localized.setLanguage(language);
    }

    return localized;
  }

  static isLocalized(localized) {
    const user = UserSession.getUser();
    const language =
      user && user.party && user.party.isoLanguage
        ? user.party.isoLanguage.isoCode
        : undefined;

    return (
      localized.getLanguage() === language ||
      (language === undefined &&
        ((navigator.language &&
          navigator.language.startsWith(localized.getLanguage())) ||
          (navigator.userLanguage &&
            navigator.userLanguage.startsWith(localized.getLanguage()))))
    );
  }
}

export default LocalizationUtil;
